import React from 'react';
import styles from './styles.module.scss';

const CustomerItem = ({
                        customerID,
                        firstName,
                        lastName,
                        phone,
                        email,
                        idNumber,
                      }) => {
  return (
    <div key={customerID} className={styles.container}>
      <span className={styles.name}>{[firstName, lastName].filter(Boolean).join(' ')}</span>
      <span>{idNumber}</span>
      <span>{phone}</span>
      <span>{email}</span>
    </div>
  )
};

export default CustomerItem;
